import React from "react";
import Radio from "./Radio";

export default ({ options, onChange, label, selected, name, index = 0 }) => (
  <form className="d-flex flex-column flex-md-row mb-5">
    <label>{label}</label>
    <div className="ml-0 ml-md-4 d-flex flex-column flex-md-row">
      {options.map((option, id) => (
        <Radio
          key={id}
          id={`${index}_${option.value}`}
          onChange={onChange}
          value={option.value}
          defaultChecked={selected == option.value}
          label={option.label}
          name={name}
        />
      ))}
    </div>
  </form>
);
